const ALLOWED_EVENTS = new Set([
  'tool_view', 'tool_upload', 'tool_start', 'tool_success', 'tool_error',
  'tool_download', 'tool_reset', 'tools_hub_search', 'tools_hub_filter'
])

export function trackToolEvent(gtag, eventName, parameters = {}) {
  if (!ALLOWED_EVENTS.has(eventName) || !gtag || typeof gtag.event !== 'function') return

  const safeParameters = Object.fromEntries(
    Object.entries(parameters).filter(([key, value]) =>
      !['file_name', 'file_content'].includes(key) &&
      ['string', 'number', 'boolean'].includes(typeof value)
    )
  )
  gtag.event(eventName, safeParameters)
}

export function fileSizeBucket(bytes) {
  if (bytes < 1024 * 1024) return 'under_1mb'
  if (bytes < 5 * 1024 * 1024) return '1_to_5mb'
  return 'over_5mb'
}
